/**
 * API 요청 인터셉터
 */
import { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import { getCookie } from "../utils/cookie";


/**
 * 인증 토큰 인터셉터
 */
export const authInterceptor = {
    /**
     * 요청 전 처리
     * - API Secret 헤더 추가
     * - Access Token 추가 (필요 시)
     */
    onRequest: (
        config: InternalAxiosRequestConfig
    ): InternalAxiosRequestConfig => {
        const apiSecret = process.env.REACT_APP_API_SECRET;
        if (apiSecret) {
            config.headers['X-API-SECRET'] = apiSecret;
        }

        const accessToken = getCookie('accessToken');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        return config;
    },

    /**
     * 요청 에러 처리
     */
    onRequestError: (error: Error): Promise<Error> => {
        return Promise.reject(error);
    }
}
